import { TermCourseQuery } from '../../term_courses/queries/term_courses_query';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { SectionTypeFilters } from '../../term_courses/filters/section_type_filters';
import { RequisiteServant, RequisiteNode } from 'biz-ng-requisite-tree';
import { ITermSectionTypesDatasource } from '../../term_courses/datasources/term_section_types_datasource';
import {
  ICourseDetails,
  ICourse,
  IAssociatedCourse,
  AssociatedCourse,
  ISectionType,
  ICourseRequisite,
  ITermCourse,
  ISection
} from '../../../interfaces/scheduler_interfaces';
import { CourseDetailsModel } from '../models/course_details_model';
import { IHash, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
export class CourseDetailsQuery implements IQuery {
  private _result?: {
    course: IAssociatedCourse;
    coreqs: Array<IAssociatedCourse | ICourseRequisite>;
    prereqs: Array<IAssociatedCourse | ICourseRequisite>;
    hasAllCoRequisitesSatisfied: boolean;
    preReqHtml: string;
    isPlanned: boolean;
    hasTests: boolean;
    hasPreRequisiteIssue: boolean;
    sectionUsedToFetchCourseDetails?: ISection['id'];
    testRequirementText: string;
    preRequirementIssueText: string;
  };

  constructor(
    QueryMediator: IQueryMediator,
    private ngCourseDetailsModel: CourseDetailsModel,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private appConfigModel: any,
    private ngTermCourseQuery: TermCourseQuery
  ) {
    QueryMediator.registerQuery(this, ngCourseDetailsModel);
  }
  /* tslint:disable:cognitive-complexity */
  run() {
    const { course_detail: course_details, sectionUsedToFetchCourseDetails } = this.ngCourseDetailsModel.read();

    if (!course_details) {
      this._result = undefined;
      return this;
    }

    const course = _4.first(_4.toArray(course_details.course));
    if (!course) {
      this._result = undefined;
      return this;
    }

    const termCourse = (this.ngTermCoursesDatasource.get(course.id) as ITermCourse) || {};

    // PreRequisite information
    const filterTestScores = this.appConfigModel.isFeatureEnabled('cat-hide_test_node_in_prereq');
    const preReqsForHTML = filterTestScores
      ? _4.filter(course_details.prereq, (req: RequisiteNode) => !RequisiteServant.isTestTypeRequisite(req))
      : course_details.prereq;

    const preReqHtml = RequisiteServant.getRequisiteHtml(preReqsForHTML, course_details.associated_course as any);
    const hasTests: boolean = RequisiteServant.hasTestPreRequisite(course_details.prereq);
    const testRequirementText = RequisiteServant.getPreRequisiteTestIssueText(
      _4.lowerCase(_4.get(this.appConfigModel, 'model.member_configs.advisor_label'))
    );
    const hasPreRequisiteIssue: boolean = RequisiteServant.hasPreRequisiteIssues(course_details.prereq);
    const preRequirementIssueText = RequisiteServant.getPreRequisiteIssueText();
    // End PreRequisite information

    if (_4.get(termCourse, '_section_types')) {
      termCourse._section_types = _4.uniqBy(termCourse._section_types, 'name');
    }

    const mapRequisites = (
      requisites: Record<string, ICourseRequisite>,
      associatedCourses: Record<string, IAssociatedCourse>
    ) =>
      _4.map(requisites, (req) => {
        if (req.type === 'COURSE' || req.type === 'GRADE') {
          const requisite = course_details.associated_course[req.course];
          const range = !!req.range ? `(${req.range})` : '';
          const title = requisite ? `${requisite.cd} ${requisite.title} ${range}` : req.title;
          return {
            ...req,
            title,
            _course: requisite,
            isCoursePlanned:
              requisite &&
              !_4.isUndefined(
                _4.find(this.ngTermCourseQuery.result.planned, (plannedCourse) => plannedCourse.id === requisite.id)
              )
          };
        } else if (req.type === 'TEST') {
          const range = !!req.range ? `(${req.range})` : '';
          req.title = `${req.test} ${range}`;
          return req;
        } else {
          return req;
        }
      });
    const coreqs = mapRequisites(course_details.coreq, course_details.associated_course);
    const prereqs = mapRequisites(course_details.prereq, course_details.associated_course);
    this._result = {
      course: _4.assign({}, course, termCourse),
      coreqs,
      prereqs,
      preReqHtml,
      hasTests,
      sectionUsedToFetchCourseDetails,
      hasPreRequisiteIssue,
      testRequirementText,
      preRequirementIssueText,
      hasAllCoRequisitesSatisfied: _4.isEmpty(_4.get(termCourse, '_missing_coreqs', [])),
      isPlanned: !_4.isUndefined(
        _4.find(this.ngTermCourseQuery.result.planned, (plannedCourse) => plannedCourse.id === course.id)
      )
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCourseDetailsQuery', CourseDetailsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/queries/course_details_query.ts